export const environment = {
  production: false,
  pre: false,
  qa: true,

  allowedParentOriginOTP: 'http://messika-cms.localhost; https://preprod-bymessika-challenge.messika.xyz',
  companyContactEmail: 'bymessika@messikagroup.com',

  apiClient: 'https://clients.mesqa.ri.dentsutracking.com/qa',
  mfaClient: 'https://auth.mesqa.ri.dentsutracking.com/qa',

  awsMapApiKey: 'v1.public.eyJqdGkiOiIzNWVmMTQ0MC02ZTM4LTQwMGYtYmE1ZS1hYWExZjAxNGFhZGEifWD56pwjx4vBexTLY_Feu8jpwpNaKc9XvL1HgU-anVs6lCreune-CZ-lgfJLa_695XiCmhJycUMokW2VOUv0MwEL4bA0boMI2QREfre8r5fM2FmgPNhhBMREdYEJJQ8owfZXHgx45mx3nPF2Nla72I7ru99OrU729TrI43G-7eXQqga7PmfHTSHeXBusG3Q8aigYIpia-Hi7JMK0If3jAGR4PQBSasibRtOUfpqhlnUGV1SzpRKXpCJXNoLjFdgbewWZjYmMioOmq1dmzH95r8zJh3lQFP7wGNT2VAMKdknBnsYJGfdiloQsIOzawxEZRQ8t2b_6k3nrmy2HG2gyxHk.ZGQzZDY2OGQtMWQxMy00ZTEwLWIyZGUtOGVjYzUzMjU3OGE4',
  awsRegion: 'eu-west-1',

  dynamsoft: {
    productKey: 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAwNTAzMjkzLXIxNzM5Mjg3NDYwIiwibWFpblNlcnZlclVSTCI6Imh0dHBzOi8vbWx0cy5keW5hbXNvZnQuY29tLyIsIm9yZ2FuaXphdGlvbklEIjoiMTAwNTAzMjkzIiwic3RhbmRieVNlcnZlclVSTCI6Imh0dHBzOi8vc2x0cy5keW5hbXNvZnQuY29tLyIsImNoZWNrQ29kZSI6NjU1OTIyODg3fQ=='
  }
};
